var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SelecaoDeProjetoDeSubsidio.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-715517fd\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SelecaoDeProjetoDeSubsidio.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/selecao-de-projeto-de-subsidio/SelecaoDeProjetoDeSubsidio.vue
// module id = 1070
// module chunks = 1